import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary, { accordionSummaryClasses } from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { colors } from 'theme/colors';
import { Grid } from '@mui/material';
import { margin } from '@mui/system';

interface AccordionContainerProps {
  maxVisibleItems?: number;
}

export const AccordionContainer = styled('div')<AccordionContainerProps>(
  ({ maxVisibleItems }) => ({
    ...(maxVisibleItems && {
      maxHeight: `calc(${maxVisibleItems * 60}px + 100px)`,
      overflowY: 'auto',
    }),
  }),
);

export const StyledAccordion = styled(MuiAccordion)({
  border: `1px solid ${colors.primary50}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: 0,
  },
  margin: 0,
});

export const StyledAccordionSummary = styled(MuiAccordionSummary)({
  backgroundColor: colors.primary15,
  flexDirection: 'row-reverse',
  minHeight: '48px !important',
  padding: '8px',
  margin: 0,
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: 1,
    margin: `0 0 0 8px`,
    minWidth: 0,
  },
  '.icon-minus, .icon-plus': {
    border: `2px solid ${colors.primary900}`,
    width: '15px',
    height: '15px',
  },
  [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
    position: 'relative',

    '.icon-minus': {
      display: 'none',
    },

    '.icon-plus': {
      display: 'flex',
    },
  },
  [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]: {
    '.icon-minus': {
      display: 'flex',
    },

    '.icon-plus': {
      display: 'none',
    },
  },
  '&.Mui-expanded': {
    minHeight: '48px !important',
    backgroundColor: colors.white,
    gap: '8px',
  },
});

export const StyledAccordionDetails = styled(MuiAccordionDetails)({
  padding: '8px',
});

interface IStyledComment {
  first: boolean;
}

export const StyledComment = styled(Grid)<IStyledComment>(({ first }) => ({
  ...(!first && {
    marginLeft: '32px',
  }),
  padding: '16px',
  gap: '8px',
  background: colors.gray100,
  marginBottom: '8px',
}));
